import LabelText from './LabelText'

export default LabelText
